module.exports = __webpack_public_path__ + "static/media/treatment.a44c0803.jpg";